<h2 mat-dialog-title>Reset Password</h2>
<mat-dialog-content>
  <p class="dialog-subtitle">Set a new password for <strong>{{ data.userName }}</strong></p>
  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>New Password</mat-label>
      <input matInput type="password" formControlName="newPassword" maxlength="50" />
      <mat-error *ngIf="submitted && form.get('newPassword')?.errors?.['required']">
        Password is required
      </mat-error>
      <mat-error *ngIf="submitted && form.get('newPassword')?.errors?.['minlength']">
        Minimum 6 characters
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Confirm Password</mat-label>
      <input matInput type="password" formControlName="confirmPassword" maxlength="50" />
      <mat-error *ngIf="submitted && form.errors?.['mismatch']">
        Passwords do not match
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()">Update Password</button>
</mat-dialog-actions>
